import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Who is a suitable candidate?",
    a: "Adults experiencing heaviness, hooding or excess skin around the upper or lower eyelids, in good general health and seeking a natural, restorative result. Suitability is confirmed during your pre-operative consultation.",
  },
  {
    q: "How long is the procedure?",
    a: "Upper blepharoplasty typically takes 45–60 minutes under local anaesthesia. The combined upper and lower procedure takes 90–120 minutes. Sedation options are available if preferred.",
  },
  {
    q: "What is the recovery like?",
    a: "Stitches are removed on day 7. Most patients are comfortable returning to social engagements within 7–10 days, with subtle residual swelling fully resolving by week three.",
  },
  {
    q: "Where will my surgery take place?",
    a: "All procedures are performed in our central-London accredited surgical suite, with full perioperative care and discreet concierge service throughout your journey.",
  },
  {
    q: "Why are these rates being offered?",
    a: "Blepharoplasty with Dr Vahe is available year-round in London — at Dr Vahe Clinic. The current preferred rates are designed to make specialist upper and combined eyelid surgery more accessible, subject to consultation and availability.",
  },
  {
    q: "How do I arrange a consultation?",
    a: "Submit your enquiry below. Our clinical coordinator will contact you within 4 working hours to arrange your consultation and discuss your preferred surgical date.",
  },
];

const FAQ = () => {
  return (
    <section id="faq" className="bg-linen-deep py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-5xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4">
          <span className="text-[10px] tracking-[0.35em] uppercase text-accent font-medium">
            Considered Answers
          </span>
          <h2 className="font-display text-4xl md:text-5xl mt-4 text-foreground">
            Clinical <span className="italic">Inquiries</span>
          </h2>
          <p className="mt-6 text-muted-foreground font-light leading-relaxed">
            Everything you need to know before you decide. For anything else, our team is one
            message away.
          </p>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-border">
                <AccordionTrigger className="text-left font-display text-lg md:text-xl text-foreground hover:text-accent hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-light leading-relaxed text-base pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
